import { n as _export, r as details, t as summary } from "./summary.js";
import { queryOptions, useQuery } from "@tanstack/react-query";
//#region src/__generated__/internal/monitoring/hooks/useDetails.ts
const detailsQueryKey = ({ query }) => [{ url: "/api/mdm/internal/api/internal/monitoring/requests" }, ...query ? [query] : []];
function detailsQueryOptions({ query }, config = {}) {
	const queryKey = detailsQueryKey({ query });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await details({
				...config,
				query,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @description Одинаковый metric используется для popover и перехода в реестр; railway сохраняет контекст дорог. page с нуля, size до 100. Порядок: дата поступления по убыванию, id. Все ACTIVE_* включают только активные заявки.
* @summary Заявки выбранного показателя
* {@link /api/mdm/internal/api/internal/monitoring/requests}
*/
function useDetails({ query }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { query: typeof query === "function" ? query() : query };
	const queryKey = resolvedOptions?.queryKey ?? detailsQueryKey(resolvedParams);
	const queryResult = useQuery({
		...detailsQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/internal/monitoring/hooks/useExport.ts
const exportQueryKey = ({ query } = {}) => [{ url: "/api/mdm/internal/api/internal/monitoring/export" }, ...query ? [query] : []];
function exportQueryOptions({ query } = {}, config = {}) {
	const queryKey = exportQueryKey({ query });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await _export({
				...config,
				query,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Экспорт свежего среза мониторинга в Excel
* {@link /api/mdm/internal/api/internal/monitoring/export}
*/
function useExport({ query } = {}, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { query: typeof query === "function" ? query() : query };
	const queryKey = resolvedOptions?.queryKey ?? exportQueryKey(resolvedParams);
	const queryResult = useQuery({
		...exportQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/internal/monitoring/hooks/useSummary.ts
const summaryQueryKey = ({ query } = {}) => [{ url: "/api/mdm/internal/api/internal/monitoring" }, ...query ? [query] : []];
function summaryQueryOptions({ query } = {}, config = {}) {
	const queryKey = summaryQueryKey({ query });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await summary({
				...config,
				query,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @description Повторяемый railway фильтрует все блоки. Без фильтра — все доступные дороги. percent — число от 0 до 100 с одним знаком; amount — точная сумма в рублях. Сегодняшние заявки без плашки входят в активные, но не в четыре категории срока.
* @summary Все показатели мониторинга
* {@link /api/mdm/internal/api/internal/monitoring}
*/
function useSummary({ query } = {}, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { query: typeof query === "function" ? query() : query };
	const queryKey = resolvedOptions?.queryKey ?? summaryQueryKey(resolvedParams);
	const queryResult = useQuery({
		...summaryQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
export { exportQueryOptions as a, detailsQueryOptions as c, exportQueryKey as i, useDetails as l, summaryQueryOptions as n, useExport as o, useSummary as r, detailsQueryKey as s, summaryQueryKey as t };

//# sourceMappingURL=useSummary.js.map